(ns common.schema.entities.calculated.indirect-holding
  (:require [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (vec
   (concat (su/single-ref-field :indirect-holding/fund "Fund" [:entity.type/fof-asset]
                                (system-controlled
                                 {:artificial?               true
                                  :grid-type                 :editor.type/link
                                  :default-field-visibility :in-use
                                  ;; Lets the dedicated-index materialization pipeline
                                  ;; (backend.domain.entities.materialization.flatten/
                                  ;; materialize-deep-indexed-ref-fields) flatten every one
                                  ;; of the fund's own fields into this listing's search
                                  ;; document, the same mechanism investor/legal-entity
                                  ;; already relies on - no custom flattening code needed.
                                  :deep-indexing?           true
                                  :authorization             su/access-system-user}))
           (su/single-ref-field :indirect-holding/holding-target "Holding" [:entity.type/company :entity.type/real-estate :entity.type/other-asset]
                                (system-controlled
                                 {:artificial?               true
                                  :grid-type                 :editor.type/link
                                  :default-field-visibility :in-use
                                  :deep-indexing?           true
                                  :authorization             su/access-system-user})))))
